import { ActionReducerMap } from '@ngrx/store';
import { AuthenticationState } from './state';
import { authenticationReducer } from './auth/authentication.reducer';
import { listingsReducer } from './listings/listings-reducer';
import { ListingState } from './listings/listings-selector';
import { SharedReducer } from './shared/reducers';
import { SharedState } from './shared/state';
import { eventLogReducer } from './event-log-store/reducer';
import { EventLogStoreState } from './event-log-store';
import { UserReducer } from './users/reducers';
import { UserState } from './users/state';
import { guestWishlistReducer } from './wishlist/reducers';
import { WishlistState } from './wishlist/state';
import { payoutsReducer } from './payouts/payouts.reducer';
import { PayoutsState } from './payouts/payouts.state';

export interface RootReducerState {
  auth: AuthenticationState;
  listings: ListingState;
  shared: SharedState;
  eventLog: EventLogStoreState.State;
  users: UserState;
  wishlist: WishlistState;
  payouts: PayoutsState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
  eventLog: eventLogReducer,
  auth: authenticationReducer,
  listings: listingsReducer,
  shared: SharedReducer,
  users: UserReducer,
  wishlist: guestWishlistReducer,
  payouts: payoutsReducer,
};
